// extracted by mini-css-extract-plugin
module.exports = {"row":"BrandChatsList__row___2wP2v","active":"BrandChatsList__active___1T7G_"};